export default "__VITE_ASSET__CsUJXVPL__"